import { apiClient } from './client';
import type { ImportRecord, ImportDetail, ImportBatch, ImportBatchDetail } from '@/types/models';

interface ImportHistoryResponse {
  data: ImportRecord[];
  count: number;
}

export const importApi = {
  upload: async (xlsx: File, pdfs: File[]): Promise<ImportBatch> => {
    const formData = new FormData();
    formData.append('xlsx', xlsx);
    pdfs.forEach(pdf => formData.append('pdfs', pdf));

    const response = await apiClient.post<ImportBatch>('/v1/import/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  getHistory: async (page = 1, limit = 20): Promise<ImportHistoryResponse> => {
    const response = await apiClient.get<ImportHistoryResponse>('/v1/import/history', {
      params: { page, limit },
    });
    return response.data;
  },

  getDetail: async (importId: number): Promise<ImportDetail> => {
    const response = await apiClient.get<ImportDetail>(`/v1/import/${importId}`);
    return response.data;
  },

  getBatchDetail: async (batchId: number): Promise<ImportBatchDetail> => {
    const response = await apiClient.get<ImportBatchDetail>(`/v1/import/batch/${batchId}`);
    return response.data;
  },
};
